// libraries.
import { Dropdown, Form } from 'react-bootstrap';

// icons.
import filterIcon from '../../assets/icons/filter-icon.svg';

// styles.
import { WrapperInputField } from './styles';

interface MultiSelectDropdownProps {
  options: { value: string; label: string }[];
  onChange?: (selected: string[]) => void;
  value?: string[];
}

export const MultiSelectDropdown = ({
  options,
  onChange,
  value = [],
}: MultiSelectDropdownProps) => {
  const allOptionValues = options.map(option => option.value);

  const selected = value;

  // Se compara por contenido y no por cantidad: `selected` puede traer valores
  // obsoletos (p. ej. agentes de otro país) que igualan la longitud sin que las
  // opciones visibles estén realmente marcadas.
  const isAllSelected =
    allOptionValues.length > 0 &&
    allOptionValues.every(option => selected.includes(option));

  const handleSelect = (optionValue: string) => {
    let newSelected: string[];

    if (optionValue === 'ALL') {
      newSelected = isAllSelected ? [] : allOptionValues;
    } else {
      newSelected = selected.includes(optionValue)
        ? selected.filter(item => item !== optionValue)
        : [...selected, optionValue];
    }

    onChange?.(newSelected);
  };

  return (
    <WrapperInputField>
      <Dropdown>
        <Dropdown.Toggle className="w-100 multi-dropdown">
          <img src={filterIcon} />
        </Dropdown.Toggle>
        <Dropdown.Menu className="wrapper-items" flip={true}>
          <Dropdown.Item as="div" onClick={e => e.stopPropagation()}>
            <Form.Check
              type="checkbox"
              id="checkbox-all"
              label="Todos"
              checked={isAllSelected}
              onChange={() => handleSelect('ALL')}
            />
          </Dropdown.Item>

          {options.map(option => (
            <Dropdown.Item
              key={option.value}
              as="div"
              onClick={e => e.stopPropagation()}
            >
              <Form.Check
                type="checkbox"
                id={`checkbox-${option.value}`}
                label={option.label}
                checked={selected.includes(option.value)}
                onChange={() => handleSelect(option.value)}
              />
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </WrapperInputField>
  );
};
